import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { Modal } from '../../../../ui'
import { ButtonsBlock } from '../../../../Edit/components'
import useRequest from '../../../../hooks/useRequest'
import { postApprove } from '../../../config'
import { Alert } from 'antd'
import {useCurrentUser} from "../../../../hooks/useCurrentUser";
import IAppState from 'store/states'
import { useSelector } from 'react-redux'
import moment from 'moment'
import {signBody} from "../../../../helpers";
import { useTranslation } from 'react-i18next'
import style from './style.m.less'
import { QuestionCircle } from '../../../../../assets/icons'

interface IApproveModal {
    isModalVisible: boolean
    setIsModalVisible: (value: boolean) => void
    currentDate: string
    id?: string
}

const ApproveModal: FC<IApproveModal> = ({
    isModalVisible,
    setIsModalVisible,
    currentDate,
    id,
}) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { fetch } = useRequest(postApprove)
    const userInfo = useSelector((store: IAppState) => store.user)
    const { data } = userInfo
    const { isUserAdmin } = useCurrentUser()
    const isEmptySign = isUserAdmin && !data?.certificate_data
    const isSignExpired = isUserAdmin && !isEmptySign && !moment(data?.certificate_data.token_expiration).isAfter()

    const handleOk = () => {
        setIsModalVisible(false)
    }

    const getBack = async () => {
        const body = {
            id: Number(id),
            action_type_id: 1
        }
        if (isUserAdmin) {
            const { request_id, signature } = await signBody(body, data)
            fetch({
                body,
                getParams: {
                    request_id,
                },
                config: {
                    headers: {
                        Signature: signature,
                    },
                },
                successMessage: {
                    title: 'Успешно',
                    description: `Данные КУ за ${currentDate.toLowerCase()} согласованы`,
                },
                errorCodeMessage: true,
                onSuccess: () => navigate(-1),
            })
        } else {
            fetch({
                body,
                successMessage: {
                    title: 'Успешно',
                    description: `Данные КУ за ${currentDate.toLowerCase()} согласованы`,
                },
                errorCodeMessage: true,
                onSuccess: () => navigate(-1),
            })
        }
    }

    return (
        <Modal isModalVisible={isModalVisible}>
            <div className={style.modalWrapper}>
                <div className={style.headerWrapper}>
                    <QuestionCircle />
                    <div className={style.header}>Согласовать данные</div>
                </div>
            </div>
            <div
                className={style.text}
            >{`Вы уверены, что хотите согласовать данные КУ за ${currentDate.toLowerCase()}?`}</div>
            {(isEmptySign || isSignExpired) && (
                <Alert
                    className={style.signError}
                    message={isEmptySign ? 'Не установлена ЭП' : 'Истек срок действия ЭП'}
                    type="error"
                    showIcon
                />
            )}
            <div className={style.buttonsBlock}>
                <ButtonsBlock
                    confirmAction={getBack}
                    cancelAction={handleOk}
                    confirmTitle={isUserAdmin
                        ? t('questionnaireApprovalItem.signAndApproveButton')
                        : t('questionnaireApprovalItem.approveButton')}
                    confirmDisabled={isEmptySign || isSignExpired}
                />
            </div>
        </Modal>
    )
}

export default ApproveModal
